// =============================================
// CART BADGE - DYNAMIC UPDATE (AJAX INTERCEPT)
// =============================================

let previousCount = 0;

function updateCartBadge(triggerPulse = false) {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const bubble = document.querySelector('.cart-count-bubble');
      const span = bubble?.querySelector('span[aria-hidden="true"]');
      if (!bubble || !span) return;

      if (cart.item_count > 0) {
        span.textContent = cart.item_count;
        bubble.style.display = 'flex';

        // ── Pulse animation when a new item is added ──
        if (triggerPulse && cart.item_count > previousCount) {
          bubble.classList.remove('cart-badge--pulse');
          void bubble.offsetWidth; // force reflow to restart animation
          bubble.classList.add('cart-badge--pulse');
        }

      } else {
        bubble.style.display = 'none';
      }

      previousCount = cart.item_count;
    });
}

// ── 1. Intercept fetch() calls to cart endpoints ──
const _originalFetch = window.fetch;
window.fetch = function(...args) {
  const url = args[0];
  const isCartCall = typeof url === 'string' && (
    url.includes('/cart/add') ||
    url.includes('/cart/change') ||
    url.includes('/cart/update') ||
    url.includes('/cart/clear')
  );

  const result = _originalFetch.apply(this, args);

  if (isCartCall) {
    result.then(() => setTimeout(() => updateCartBadge(true), 300));
  }

  return result;
};

// ── 2. Intercept XMLHttpRequest (older AJAX) ──
const _originalXHROpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function(method, url, ...rest) {
  const isCartCall = typeof url === 'string' && (
    url.includes('/cart/add') ||
    url.includes('/cart/change') ||
    url.includes('/cart/update') ||
    url.includes('/cart/clear')
  );

  if (isCartCall) {
    this.addEventListener('load', () => setTimeout(() => updateCartBadge(true), 300));
  }

  return _originalXHROpen.call(this, method, url, ...rest);
};

// ── 3. Listen to Shopify & common theme events ──
['cart:updated', 'cart:refresh', 'cart:change', 'theme:cart:updated'].forEach(event => {
  document.addEventListener(event, () => updateCartBadge(true));
});

// ── 4. Run on page load (no pulse on initial load) ──
document.addEventListener('DOMContentLoaded', () => updateCartBadge(false));